import { useEffect, useRef } from 'react';
import { PORTFOLIOS } from 'routes';
import { useLocation } from 'react-router-dom';
import { ExportGridRef } from '@ihsm/ui-shared';
import { useActions } from 'state/store';

export type UsePortfolioPage = {
  exporterRef: React.RefObject<ExportGridRef>;
  onExport: () => void;
};

export const usePortfolioPage = (): UsePortfolioPage => {
  const exporterRef = useRef<ExportGridRef>(null);
  const { setMeasureType } = useActions();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith(PORTFOLIOS)) {
      setMeasureType('Abs');
    }
  }, [setMeasureType, pathname]);

  const onExport = () => {
    exporterRef?.current?.exportGrid();
  };

  return { exporterRef, onExport };
};
